import { NgModule } from '@angular/core';
import { Routes,RouterModule } from '@angular/router';
import { OpdVisitsComponent } from './opdvisits.component';


const opdvisitsroutes: Routes = [

    {path: 'opdvisits', component: OpdVisitsComponent, children: [
         //{path: 'test/:id', component: OpdVisitsComponent}
       

    ]}
]

@NgModule({
 imports: [
        RouterModule.forChild(opdvisitsroutes)
    ],
    exports: [RouterModule]
}
)
export class OpdVisitsRoutingModule {

}